import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, Loader2, XCircle } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_b7533cee-6cc1-4a41-9e88-4b20184fec89/artifacts/eixt3fs2_STM%20mobile%20logo.png';

const Success = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    // If we have a session_id, the payment was successful
    if (sessionId) {
      setStatus('success');
    } else {
      setStatus('error');
    }
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#0B0F1A' }}>
      <div className="max-w-md w-full mx-4">
        <div className="text-center">
          {/* Logo */}
          <Link to="/" className="inline-flex items-center gap-3 mb-8">
            <img 
              src={LOGO_URL} 
              alt="ScopeTheMarket" 
              className="h-12 w-auto"
              style={{ filter: 'drop-shadow(0 0 8px rgba(59, 130, 246, 0.5))' }}
            />
            <span className="text-2xl font-semibold tracking-tight" style={{ color: '#F8FAFC' }}>
              ScopeTheMarket
            </span>
          </Link>

          {/* Status Card */}
          <div 
            className="p-8 rounded-2xl"
            style={{ 
              backgroundColor: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.08)'
            }}
          >
            {status === 'loading' && (
              <>
                <Loader2 className="h-16 w-16 mx-auto mb-4 animate-spin" style={{ color: '#3B82F6' }} />
                <h1 className="text-2xl font-bold mb-2" style={{ color: '#F8FAFC' }}>
                  Processing...
                </h1>
                <p style={{ color: '#94A3B8' }}>
                  Please wait while we confirm your payment.
                </p>
              </>
            )}

            {status === 'success' && (
              <>
                <div 
                  className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: 'rgba(34, 197, 94, 0.15)' }}
                >
                  <CheckCircle className="h-10 w-10" style={{ color: '#22C55E' }} />
                </div>
                <h1 className="text-2xl font-bold mb-2" style={{ color: '#F8FAFC' }}>
                  Payment Successful!
                </h1>
                <p className="mb-6" style={{ color: '#94A3B8' }}>
                  Thank you for subscribing to ScopeTheMarket Pro. 
                  You now have access to all premium features.
                </p>
                <div className="space-y-3">
                  <Link
                    to="/app"
                    className="block w-full py-3 px-4 rounded-lg font-medium text-white text-center transition-colors"
                    style={{ backgroundColor: '#3B82F6' }}
                  >
                    Go to Dashboard
                  </Link>
                  <Link
                    to="/billing"
                    className="block w-full py-3 px-4 rounded-lg font-medium text-center transition-colors"
                    style={{ color: '#94A3B8', backgroundColor: 'rgba(255,255,255,0.05)' }}
                  >
                    View Subscription
                  </Link>
                </div>
              </>
            )}

            {status === 'error' && (
              <>
                <div 
                  className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: 'rgba(239, 68, 68, 0.15)' }}
                >
                  <XCircle className="h-10 w-10" style={{ color: '#EF4444' }} />
                </div>
                <h1 className="text-2xl font-bold mb-2" style={{ color: '#F8FAFC' }}>
                  Something Went Wrong
                </h1>
                <p className="mb-6" style={{ color: '#94A3B8' }}>
                  We couldn't confirm your payment. Please try again or contact support.
                </p>
                <div className="space-y-3">
                  <Link
                    to="/pricing"
                    className="block w-full py-3 px-4 rounded-lg font-medium text-white text-center transition-colors"
                    style={{ backgroundColor: '#3B82F6' }}
                  >
                    Try Again
                  </Link>
                  <Link
                    to="/"
                    className="block w-full py-3 px-4 rounded-lg font-medium text-center transition-colors"
                    style={{ color: '#94A3B8', backgroundColor: 'rgba(255,255,255,0.05)' }}
                  >
                    Go Home
                  </Link>
                </div>
              </>
            )}
          </div>

          {/* Session ID for debugging */}
          {sessionId && (
            <p className="mt-4 text-xs" style={{ color: '#64748B' }}>
              Session: {sessionId.substring(0, 20)}...
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Success;
